import { getContentfulClient } from "@tiicker/util/lib/contentful/client";
import {
  ContentSections,
  getImageReference,
  getItemReference,
  loadContentSections,
} from "@tiicker/util/lib/contentful/helpers";
import {
  ContentfulContentType,
  ContentfulKey,
  GenericMarketingPage,
  PageSection,
  PageSectionKey,
} from "@tiicker/util/lib/contentful/types";
import FooterV2 from "components/FooterV2/FooterV2";
import HowItWorksView from "components/HowItWorks/HowItWorksView";
import StartEarningPerksMadi from "components/StartEarningPerksMadi/StartEarningPerksMadi";
import { Entry, EntryCollection } from "contentful";
import { compact } from "lodash";
import { GetStaticProps } from "next";
import React from "react";

type Props = {
  pageContent: EntryCollection<GenericMarketingPage>;
  cta: Entry<PageSection> | undefined;
  pageSections: Entry<PageSection>[];
  contentSections: ContentSections;
};

const HowItWorks = (props: Props) => {
  return (
    <>
      <HowItWorksView {...props} showNavigationBar />
      {props.cta && (
        <StartEarningPerksMadi
          page={props.cta}
          includes={props.contentSections.includes}
        />
      )}
      <FooterV2 />
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = getContentfulClient("contentful");

  const howItWorksContent = await client.getEntries<GenericMarketingPage>({
    content_type: ContentfulContentType.GenericMarketingPage,
    ["fields.key"]: ContentfulKey.HowItWorksPage,
  });

  const page =
    howItWorksContent.items.length > 0 ? howItWorksContent.items[0] : null;
  const pageSections = compact(
    page?.fields.pageSections?.map((section) =>
      getItemReference(section, howItWorksContent.includes)
    )
  );

  const cta = pageSections.find(
    (x) => x.fields.sectionKey === PageSectionKey.JoinNowCTA
  );

  const contentSections = await loadContentSections(client, pageSections);
  const howitWorks = howItWorksContent.items[0];

  const title = howitWorks.fields.displayTitle
  const description =  howitWorks.fields.displayDescription

  return {
    props: {
      pageContent: howItWorksContent,
      cta,
      pageSections,
      contentSections,
      title, 
      description
    },
  };
};

export default HowItWorks;
